import { lazy, Suspense } from 'react';
import * as Sentry from '@sentry/react';

// Isolated from App providers so /login never imports Karla / drawer / echarts.
const KarlaChatLauncher = lazy(() => import('./KarlaChatLauncher'));
const karlaErrorFallback = () => <></>;

const KarlaChatLauncherGate = () => (
  <Suspense fallback={null}>
    <Sentry.ErrorBoundary fallback={karlaErrorFallback}>
      <KarlaChatLauncher />
    </Sentry.ErrorBoundary>
  </Suspense>
);

export default KarlaChatLauncherGate;
